import React from 'react';
import PropTypes from 'prop-types';
import {
  branch,
  compose,
  withProps,
  withHandlers,
} from 'recompose';
import Auth from '../Auth/index';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import { willShowModal } from '../Common/Modal/Modal';
import { HTMLTrans, withTranslation } from '../Common/Translations';

const withModal = willShowModal({ size: 'md' });

const withOnPurchaseHandler = withHandlers({
  onPurchaseHandler: ({ purchasePromotion, selectedPromotionId }) => () => {
    purchasePromotion(selectedPromotionId);
  },
});

export const hasLoginModal = (Comp) => {
  const Modal = withModal(Comp);

  return ({ onPurchaseHandler, counterExpired }) =>
    (
      <Modal counterExpired={counterExpired} >
        {closeModal => (
          <Auth
            closeModal={closeModal}
            onTokenUpdate={onPurchaseHandler}
          />
        )}
      </Modal>
    );
};

export function PurchaseButton({
  counterExpired,
  purchasePromotion,
}) {
  return (
    <button
      type='button'
      className='btn btn-lg btn-block btn-secondary'
      id='buyNowButton'
      disabled={counterExpired}
      onClick={purchasePromotion}
    >
      {counterExpired ? <HTMLTrans id="promotion.purchasebutton_notavailable">NO LONGER AVAILABLE</HTMLTrans> : <HTMLTrans id="promotion.purchasebutton_buynow">BUY NOW</HTMLTrans>}
    </button>
  );
}

const isNotLoggedIn = ({ isLoggedIn }) => !isLoggedIn;

const withLoginModalIfUnauthenticated = compose(
  connectUserHeaderinfo,
  withProps(({ userHeaderInfo: { isLoggedIn } }) => ({ isLoggedIn })),
  withOnPurchaseHandler,
  branch(
    isNotLoggedIn,
    hasLoginModal,
  ),
);

PurchaseButton.propTypes = {
  counterExpired: PropTypes.bool,
  purchasePromotion: PropTypes.func,
};

const AuthenticablePurchaseButton = withLoginModalIfUnauthenticated(PurchaseButton);

export default withTranslation('promotion')(AuthenticablePurchaseButton);



// WEBPACK FOOTER //
// ./src/Promotion/PurchaseButton.js